module.exports = __webpack_public_path__ + "img/public/SiteIcons/stepCompletedIcon.svg?b94e470a";